import { Component, Input, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { EnrollmentAddService } from "src/app/services/enrollment-add.service";
import { CoverageTab } from "src/app/models/coverage";
import { EnrollmentManagerService } from "src/app/services/enrollment-manager.service";
import { FormValidationService } from "src/app/services/form-validation.service";
import { MaskType } from "src/app/constants/masks";
import { debounceTime } from "rxjs";
import { MaskService } from "src/app/services/mask.service";
import { BenefitWizardType } from "src/app/constants/wizard-panels";
import { FSAContribution, FSAContributionPayload } from "src/app/models/fsa";

@Component({
    selector: 'mwp-benefit-enrollment-wizard-coverage-fsa',
    templateUrl: './fsa.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FSACoverageComponent implements OnInit {
    @Input() coverageFormGroup: FormGroup;
    @Input() coverageTab: CoverageTab;

    public maskType = MaskType;
    public isValid: boolean;
    public isDeductionValid: boolean;
    public deductionAmount: number = 0;
    public isValidName: string = 'isValidName';
    public fsaAnnualContribution: string = 'fsaAnnualContribution';

    constructor(
        private maskService: MaskService,
        private enrollmentManagerService: EnrollmentManagerService,
        private enrollmentAddService: EnrollmentAddService,
    ){  
    }

    ngOnInit(): void {
        this.coverageFormGroup.get(this.fsaAnnualContribution).setValue(null);
        this.coverageFormGroup.get(this.fsaAnnualContribution).setValidators(Validators.compose([
            Validators.required, 
            Validators.min(this.coverageTab.fsaMinValue), 
            Validators.max(this.coverageTab.fsaMaxValue),
            FormValidationService.validCurrency()
        ]));
        this.coverageFormGroup.addControl(this.isValidName, new FormControl(this.isValid, Validators.requiredTrue));
        this.isAnnualDeductionValid(this.deductionAmount);

        this.coverageFormGroup.get(this.fsaAnnualContribution).valueChanges.pipe(debounceTime(700)).subscribe((val: string) => {
            if (!val) {
                this.setPageValidation(false);
                this.deductionAmount = 0;
            } else {
                const l_Amount = this.maskService.removeCurrencyMask(val);
                if (this.isAnnualDeductionValid(l_Amount)) {
                    const l_FSAContributionPayload = new FSAContributionPayload();
                    l_FSAContributionPayload.annualContribution = l_Amount;

                    switch (this.enrollmentManagerService.benefitWizardControlPanel.wizardType) {
                        case BenefitWizardType.Add:
                            this.enrollmentAddService.getFsaContribution(l_FSAContributionPayload).subscribe((response: FSAContribution) => {
                                this.deductionAmount = response.deductionAmount;
                                this.setPageValidation(true);
                            });
                            break;
                    }
                }
            }
            
        });
    }

    private isAnnualDeductionValid(amount: number): boolean {
        let l_IsValid: boolean = false;
        if (amount < this.coverageTab.fsaMinValue) {
            this.deductionAmount = 0;
            this.setPageValidation(false);
        } else if (amount > this.coverageTab.fsaMaxValue) {
            this.deductionAmount = 0;
            this.setPageValidation(false);
        } else {
            l_IsValid = true;
        }

        return this.isDeductionValid = l_IsValid;
    }

    private setPageValidation(valid: boolean): void {
        this.coverageFormGroup.get(this.isValidName).setValue(valid);
        this.coverageFormGroup.get(this.isValidName).updateValueAndValidity();
    }
}